import React from 'react';

const ArrowRight = ({ className = '' }) => {
  return (
    <div className={`arrowRight ${className}`}>
      <div>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default ArrowRight;
